let moveArr = [


  {
    ele: [".banner .bannertext"],
    distancetop: 0,
    distancebottom: 500,
    from: { opacity: 1, y: 0 },
    to: { opacity: 0, y: -200 }
  },

  {
    ele: [".solu .left"],
    distancetop: 100,
    distancebottom: 100,
    from: { opacity: 0.5, x: -2220 },
    to: { opacity: 1, x: 0 }
  },
  {
    ele: [".solu .left .right"],
    distancetop: 100,
    distancebottom: 300,
    from: { opacity: 0, y: 2220 },
    to: { opacity: 1, y: 0 }
  },
  {
    ele: [".about .top"],
    distancetop: 1000,
    distancebottom: 50,
    from: { opacity: 0, y: 1000 },
    to: { opacity: 1, y: 0 }
  },

  {
    ele: [".bot"],
    distancetop: 1200,
    distancebottom: 300,
    from: { opacity: 0, scale: 0.2 },
    to: { opacity: 1, scale: 1 }
  },
  {
    ele: [".bot .bot_box"],
    distancetop: 1900,
    distancebottom: 300,
    from: { opacity: 0, x: -20000, scale: 1.5 },
    to: { opacity: 1, x: 0, scale: 1 }
  },

  {
    ele: [".selects .title"],
    distancetop: 2500,
    distancebottom: 100,
    from: { scale: 0, y: 2000 },
    to: { scale: 1, y: 0 }
  },
  {
    ele: [".selects .flex_box .one"],
    distancetop: 2800,
    distancebottom: 100,
    from: { x: 2000 },
    to: { x: 0 }
  },

  {
    ele: [".assess"],
    distancetop: 3200,
    distancebottom: 200,
    from: { opacity: 0, scale: 0.8 },
    to: { opacity: 1, scale: 1 }
  },

  {
    ele: [".partner .title"],
    distancetop: 4000,
    distancebottom: 200,
    from: { opacity: 0, y: 200, scale: 0 },
    to: { opacity: 1, y: 0, scale: 1 }
  },

  {
    ele: [".partner .logo"],
    distancetop: 4000,
    distancebottom: 400,
    from: { opacity: 0, x: -2200, scale: 1.5 },
    to: { opacity: 1, x: 0, scale: 1 }
  },












]
export default moveArr


//////////////////
// WEBPACK FOOTER
// ./static/movedata/index.js
// module id = null
// module chunks = 